import { createI18n } from "vue-i18n/index";

const messages = {
  en: {
    home: "Home",
    dashboard: "Dashboard",
    layoutBuilder: "Layout builder",
    profile: "Profile",
    profileOverview: "Overview",
    accountSettings: "Account Settings",
    changePassword: "Change Password",
    management: "Management",
    system: {
      name: "System",
      management: "System Management",
      usersList: "User Listing",
      customerList: "Customer Listing",
      siteList: "Site Listing",
      siteModuleSettings: "Site Module Settings",
      configuration: "Update Configuration",
      records: "Operation Records",
      collection: "Tracking Log",
      siteModule: {
        name: "Site Module Configuration",
        settings: "Site Settings",
        selection: "Selection Configuration",
        recommend: "Recommend Configuration",
        search: "Search Configuration",
        envs: "Recommend Service ENV",
        product: "Product Analysis Report",
      },
    },
    selection: {
      name: "Intelligent Goods",
      my: "My Goods Programme",
      programme: "Goods Programme",
      view: "View Results",
      sorting: "Custom Sorting",
      sortingKey: "Custom Sorting Key",
    },
    search: {
      name: "Search",
      keyCorr: "Key Corr",
      keySynonym: "Key Synonym",
      keyCat: "Key Cat",
      keyRedirect: "Key Redirect",
      keywordGoods: "Keyword Goods",
      report: "Keyword Report",
      hotBlacklist: "Hot search word blacklist",
      hotTopWords: "Top search words",
    },
    recommend: {
      name: "Recommend",
      programme: "Recommend Goods",
      blackPool: "Black Pool",
      weight: "Recommend Weight",
      season: "Season",
    },
    incubation: {
      name: 'New Product Incubation',
      manual: 'Manual Operation',
    },
    report: {
      evaluation: {
        name: 'Field Data Evaluation',
        report: "Field Data Evaluation Report",
      },
      monitoring: {
        name: 'Monitoring Report',
        report: 'Api Call Statistics',
      },
      product: {
        name: 'Product Analysis Report',
        categoryName: 'Category Analysis',
        categoryOverview: 'Overview Of Categories',
        categoryChange: 'Category Change Analysis',
        categoryTrend: 'Category Trend Details',
        categoryNew: 'New Analysis',
        procuctName: 'Product Analysis',
        productList: 'Product List',
        productOverview: 'Product Overview',
        productDetails: 'Product Details Data',
        productSingle: 'Single Product Analysis',
      },
    },
    ads: {
      name: 'Ads',
      platform: 'Ads Platform',
    },
    authentication: "Authentication",
    basicFlow: "Basic Flow",
    signIn: "Sign-in",
    signUp: "Sign-up",
    passwordReset: "Password Reset",
    error404: "Error 404",
    error500: "Error 500",
    signOut: "Sign Out",
    waiting: "Please wait...",
    login: {
      signIn: "Sign In",
      username: "User Name",
      password: "Password",
      forgot: "Forgot Password",
      btn: "Continue",
      tryAgain: "Try again!",
    },
    yup: {
      required: "required",
      min: "must be at least {min} characters",
      max: "must be at most {max} characters",
      email: "must be a valid email",
      number: "must be a `number` type",
      number_min: "must be greater than or equal to {min}",
      number_max: "must be less than or equal to {max}",
    }
  },
  zh: {
    home: "首页",
    dashboard: "仪表板",
    layoutBuilder: "布局构建器",
    profile: "个人资料",
    profileOverview: "概览",
    accountSettings: "账号设置",
    changePassword: "修改密码",
    management: "管理功能",
    system: {
      name: "系统",
      management: "系统管理",
      usersList: "用户列表",
      customerList: "企业列表",
      siteList: "站点列表",
      siteModuleSettings: "站点模块配置",
      configuration: "更新配置数据",
      records: "操作记录",
      collection: "埋点数据采集",
      siteModule: {
        name: "站点模块管理",
        settings: "站点参数配置",
        selection: "智能选品配置",
        recommend: "推荐配置",
        search: "搜索配置",
        envs: "推荐接口控制",
        product: "商品分析报表配置",
      },
    },
    selection: {
      name: "智能选品",
      my: "我的选品方案",
      programme: "选品方案",
      view: "查看结果",
      sorting: "自定义排序",
      sortingKey: "自定义排序指标",
    },
    search: {
      name: "搜索",
      keyCorr: "错词改写",
      keySynonym: "同义词扩展",
      keyCat: "关键词类目绑定",
      keyRedirect: "跳转词设置",
      keywordGoods: "关键词商品置顶",
      report: "搜索词报表",
      hotBlacklist: "热搜词黑名单",
      hotTopWords: "热搜词置顶",
    },
    recommend: {
      name: "推荐",
      programme: "商品推广配置",
      blackPool: "黑名单商品",
      weight: "权重配置",
      season: "季节配置",
    },
    incubation: {
      name: '新品孵化',
      manual: '人工运营',
    },
    report: {
      evaluation: {
        name: '栏位数据评估',
        report: "栏位数据评估报表",
      },
      monitoring: {
        name: '监控报表',
        report: "API调用统计报表",
      },
      product: {
        name: '商品分析报表',
        categoryName: '类目分析',
        categoryOverview: '类目概览',
        categoryChange: '类目异动分析',
        categoryTrend: '类目趋势明细',
        categoryNew: '上新分析',
        productName: '商品分析',
        productList: '商品列表',
        productOverview: '商品概览',
        productDetails: '商品明细数据',
        productSingle: '单品分析',
      },
    },
    ads: {
      name: '广告运营',
      platform: '广告平台',
    },
    authentication: "身份验证",
    basicFlow: "基本流程",
    signIn: "登录",
    signUp: "注册",
    passwordReset: "密码重置",
    error404: "错误 404",
    error500: "错误 500",
    signOut: "退 出",
    waiting: "请稍候...",
    login: {
      signIn: "登 录",
      username: "用户账号",
      password: "密码",
      forgot: "忘记密码",
      btn: "确定",
      tryAgain: "请重试！",
    },
    yup: {
      required: "不能为空",
      min: "不能少于{min}个字符",
      max: "不能多于{max}个字符",
      email: "必须为有效的邮箱地址",
      number: "必须为数字类型",
      number_min: "不能少于{min}",
      number_max: "不能多于{max}",
    }
  }
};

const i18n = createI18n({
  legacy: false,
  locale: "en",
  globalInjection: true,
  messages,
});

export default i18n;
